import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withPolaris } from 'Components/protons/Polaris';

import './_style.scss';

/**
 * AnchorBlock component
 *
 * @param {object} props - Component props
 * @param {object} props.extraClassNames - Additional class names for styling
 * @param {React.ReactNode} props.children - Child elements to render inside the AnchorBlock
 * @param {object} props.context - Context object containing the CSS prefix
 * @param {string} props.id - Optional ID for the AnchorBlock
 */
const AnchorBlock = ({
  children,
  context: { cssPrefix },
  extraClassNames,
  id,
}) => (
  <div
    className={classNames({
      [`${cssPrefix}__anchor-block`]: true,
      ...extraClassNames,
    })}
    id={id}
  >
    {children}
  </div>
);

AnchorBlock.propTypes = {
  children: PropTypes.node,
  context: PropTypes.shape({
    cssPrefix: PropTypes.string,
  }),
  extraClassNames: PropTypes.shape(),
  id: PropTypes.string,
};

AnchorBlock.defaultProps = {
  children: null,
  context: {
    cssPrefix: '',
  },
  extraClassNames: {},
  id: undefined,
};

export default withPolaris(AnchorBlock);
